import { render } from "./PuxTabContent.pug?vue&type=template&id=a9f08a96&lang=pug"
import script from "./PuxTabContent.js?vue&type=script&lang=js"
export * from "./PuxTabContent.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__